import React, { useRef } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Popover, CloseButton } from 'react-bootstrap';
import ZoneForm from "./ZoneForm";
import ZonesList from "./ZonesList";

export default function ZonesPopover (props) {
    const { t } = useTranslation('translation', { keyPrefix: 'zonesPage' });
    const { getZones, getZoom, map, mapState, behavior, platform, highlightZoneOnMap } = props;
    const mode = useSelector(state => state.zones.mode);
    const zones = useSelector(state => state.zones.zonesList);
    const zoneFormRef = useRef();

    const zoomToZone = (position, radius) => {
        const zoom = getZoom(radius);
        if (map) {
            map.getViewModel().setLookAtData({
                position: { lat: position.lat, lng: position.lng },
                zoom: zoom
            }, true);
        }
    }

    return (
        <Popover className="zones-popover">
            {['CREATE', 'EDIT'].includes(mode) ? (
                <Popover.Header as="div">
                    <h3>{mode === 'EDIT' ? t('editZone') : t('createNewZone')}</h3>
                    <CloseButton onClick={() => zoneFormRef.current?.cancel()} />
                </Popover.Header>
            ) : ''}
            <Popover.Body>
            {['CREATE', 'EDIT'].includes(mode) ? (
                    <ZoneForm
                        ref={zoneFormRef}
                        getZones={getZones}
                        hasZones={zones.length}
                        map={map}
                        mapState={mapState}
                        behavior={behavior}
                        platform={platform}
                        zoneNames={zones.map(zone => zone.zone_name.toLowerCase())}
                    />
                ) : ''}
                {mode === 'LIST' ? (
                    <ZonesList
                        getZones={getZones}
                        hasZones={zones.length}
                        zoomToZone={zoomToZone}
                        highlightZoneOnMap={highlightZoneOnMap}
                    />
                ) : ''}
            </Popover.Body>
        </Popover>
    )
}
